import DisplayLine from './DisplayLine';
import Errors from './Errors';
import { Stack } from './layouts';
import CheckBox from './CheckBox';
import { findTranslation } from '../../utils/helpers';
import WithLabel from './WithLabel';
import {FC} from "react";

interface optionObject {
  label: string;
  value: string;
}

export interface CheckListProps {
  value?: optionObject[];
  onChange?: (e: any) => void;
  name: string;
  label?: string;
  errors?: string[] | boolean;
  disabled?: boolean;
  readOnly?: boolean;
  options: optionObject[];
}

const CheckBoxList: FC<CheckListProps> = ({
  value,
  onChange,
  name,
  errors,
  disabled,
  readOnly,
  options,
  label
}) => {
  const valueList = Array.isArray(value) ? value : [];

  if (readOnly) {
    return (
      <DisplayLine
        label={label}
        value={
          valueList.length > 0
            ? valueList
                .map(({ value }) => findTranslation(value, options))
                .join(', ')
            : null
        }
      />
    );
  }

  const input = (
    <>
      <Stack minWidth="224px" space={'s'}>
        {options.map(option => {
          const optionValue = option?.value;
          const optionLabel = option?.label;

          return (
            <CheckBox
              key={`${name}_${optionValue}`}
              name={name}
              value={valueList?.some(({ value }) => value === optionValue)}
              onChange={({ target }) => {
                const newValue = target?.value || false;
                onChange(
                  newValue
                    ? [...valueList, option]
                    : valueList.filter(({ value }) => value !== optionValue)
                );
              }}
              title={optionLabel}
              disabled={disabled}
            />
          );
        })}
      </Stack>
      {errors && <Errors errors={errors} />}
    </>
  );

  return label ? (
    <WithLabel label={label} asDiv>
      {input}
    </WithLabel>
  ) : (
    input
  );
};

export default CheckBoxList;
